import React, { useMemo } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { mapBlockToSecondarySidebar } from '../utils/blockForms.utils';

import { TemplateStudioMainSidebar } from './Main/MainSidebar';
import { TemplateStudioSecondarySidebar } from './Secondary/Secondary';

const SECONDARY_W = 203;

export const TemplateStudioSidebar: React.FC = () => {
  const { openSidebarBlock } = useTemplateStudioState();

  const BlockSecondarySidebar = useMemo(
    () => openSidebarBlock && mapBlockToSecondarySidebar[openSidebarBlock],
    [openSidebarBlock]
  );

  return (
    <div className="flex gap-4 w-fit overflow-y-hidden">
      <TemplateStudioMainSidebar />

      <AnimatePresence initial={false} mode="wait">
        {BlockSecondarySidebar && (
          <motion.div
            key={String(openSidebarBlock)}
            initial={{ width: 0 }}
            animate={{ width: SECONDARY_W }}
            exit={{ width: 0 }}
            transition={{
              duration: 0.1,
              ease: [0.22, 1, 0.36, 1],
              delay: 0
            }}
            className="overflow-hidden will-change-[width]"
          >
            <motion.div
              initial={{ x: '-100%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: '-100%', opacity: 0 }}
              transition={{ duration: 0, ease: [0.4, 0, 0.2, 1] }}
              className="h-full"
            >
              <TemplateStudioSecondarySidebar
                SidebarBlockComponent={BlockSecondarySidebar}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
